<template>
  <div style="width: 95%;">
    <template v-if="loading">
          <Loader :delay="0"></Loader>
    </template>
    <template v-else>
      <b-table class="customtable" striped hover :items="tableObjects" :fields="fields" v-if="!showcidi">
        <template slot="showCampaign" slot-scope="row">
          <b-button size="sm" class="mr-2" disabled>Campaña</b-button>
        </template>
        <template slot="showDetailsCIDI" slot-scope="row">
          <b-button size="sm" class="mr-2" @click.stop="getCidi(row.item)">Ver</b-button>
        </template>
      </b-table>
      <div v-else>
        <b-button size="sm" class="mr-2" @click="showcidi = false">Atrás</b-button>
        <b-card class="text-center mt-1" style="border-color: #7b7b7b;">
          <h2>Características</h2>
          <b-row>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="CIDI">
                <b-form-input v-model="cididata.supply_id" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="ID Suministrado CC">
                <b-form-input v-model="cididata.supply_cc_id" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Mercado">
                <b-form-input v-if="cididata.market" v-model="cididata.market.cod_market" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Status">
                <b-form-input v-if="cididata.cod_supplies_status" v-model="cididata.cod_supplies_status.status_description" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Servicio disponible">
                <b-form-input v-model="cididata.vailable_services" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Caldera centralizada">
                <b-form-input v-if="cididata.central_boiler" v-model="cididata.central_boiler.boiler_description" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Tipo combustible caldera">
                <b-form-input v-if="cididata.market && cididata.market.combustible_type" v-model="cididata.market.combustible_type.combustible_description" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Tipo uso">
                <b-form-input v-if="cididata.cod_supplies_status" v-model="cididata.use_type.use_type_description" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="text-center mt-4" style="border-color: #7b7b7b;">
          <h2>Localización</h2>
          <b-row>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Bloque">
                <b-form-input v-model="cididata.block" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Escalera">
                <b-form-input v-model="cididata.stair" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Planta">
                <b-form-input v-model="cididata.floor" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Puerta">
                <b-form-input v-model="cididata.door" disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Resto dirección">
                <b-form-input v-model="cididata.rest_address" disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="text-center mt-4" style="border-color: #7b7b7b;">
          <h2>Catastro</h2>
          <b-row>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Referencia Catastral">
                <b-form-input v-model="cididata.referencia_catastral" disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="text-center mt-4" style="border-color: #7b7b7b;">
          <h2>Servicio</h2>
          <b-row>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Última puesta en servicio">
                <b-form-input v-model="cididata.last_date_starting_up" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Último cese">
                <b-form-input v-model="cididata.last_date_suspension" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Primera puesta en servicio">
                <b-form-input v-model="cididata.first_date_starting_up" disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Resto dirección">
                <b-form-input v-model="cididata.rest_address" disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="text-center mt-4" style="border-color: #7b7b7b;">
          <h2>Derivación</h2>
          <b-row>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Estado">
                <b-form-input v-if="cididata.derivation_status" v-model="cididata.derivation_status.description" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Propiedad">
                <b-form-input v-if="cididata.derivation_property_type" v-model="cididata.derivation_property_type.description" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Primera puesta en servicio">
                <b-form-input v-model="cididata.starting_up_first_date_derivation" disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Primera captación">
                <b-form-input v-model="cididata.first_captation_date_derivation" disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="text-center mt-4" style="border-color: #7b7b7b;">
          <h2>IRC</h2>
          <b-row>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Estado">
                <b-form-input v-if="cididata.irc_status" v-model="cididata.irc_status.description" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Propiedad">
                <b-form-input v-if="cididata.irc_property_type" v-model="cididata.irc_property_type.description" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group style="font-size: 1rem;" label="Tipo gas">
                <b-form-input v-if="cididata.gas_type" v-model="cididata.gas_type.description" disabled></b-form-input>
                <b-form-input v-else disabled></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
        <b-button size="sm" class="mr-2" @click="showcidi = false">Atrás</b-button>
      </div>
    </template>
    </div>
</template>

<style>
.customtable td {
  padding: 0 !important;
}
</style>

<script>

import Loader from '@/components/Layout/Loader.vue';

export default {
  props: ['feature'],
  components: {Loader},
  data () {
    return {
      loading: false,
      showcidi: false,
      cididata: {},
      fields: [
        {key: 'supply_id', label: 'CIDI'},
        {key: 'block', label: 'Bloque'},
        {key: 'stair', label: 'Escalera'},
        {key: 'floor', label: 'Piso'},
        {key: 'door', label: 'Puerta'},
        {key: 'cod_supplies_status.status_description', label: 'Status'},
        {key: 'market.cod_market', label: 'Mercado'},
        {key: 'showCampaign', label: ''},
        {key: 'showDetailsCIDI', label: ''}
      ]
    };
  },
  methods: {
    getCidi (item) {
      this.loading = true;
      this.$http.get('residencial_extendida/' + item.id + '/').then(result => {
        this.cididata = result.data;
        this.showcidi = true;
        this.loading = false;
      });
    }
  },
  computed: {
    tableObjects: function () {
      var origin = this.feature.properties.extendidaresidencial_set;
      origin.sort(function (a, b) {
        if (a.block > b.block) return 1;
        if (a.block < b.block) return -1;

        if (a.stair > b.stair) return 1;
        if (a.stair < b.stair) return -1;

        if (a.floor > b.floor) return 1;
        if (a.floor < b.floor) return -1;

        if (a.door > b.door) return 1;
        if (a.door < b.door) return -1;
      });
      return origin;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/DetailsResidencial/Infoadicional.vue